import Vue from 'vue'
import * as GmapVue from 'gmap-vue'
import getEnv from 'src/getEnv'

Vue.use(GmapVue, {
  load: {
    key: getEnv('GOOGLE_API'),
    libraries: 'places',
    region: 'ID',
    language: 'id'
  },
  installComponents: true
})
